export default __webpack_public_path__ + "static/media/photo--lg--blitz-4.8986422c.jpg";